import * as inView from "../libs/in-view.min.js";
import $ from "../libs/jquery-3.5.1.min.js";
import {gsap} from "../libs/gsap/gsap-core.js";

export class Anim {

  constructor() {
    // console.log("Anim: constructor()");

    // Prevent transition from showing on load (when console open, etc).
    $(document).ready(() => {
      $("body").addClass("ready");

      this.attach();
    });
  }

  attach() {
    // console.log(Anim: attach()");

    // Process animation speed
    this.processStepSpeed = 2.5;

    // Process Timeline
    this.processStepTimelines = {
      "flood": gsap.timeline({
        repeat: -1,
        repeatDelay: 1.5,
        paused: true
      }),
      "wildfire": gsap.timeline({
        repeat: -1,
        repeatDelay: 1.5,
        paused: true
      }),
      "smog": gsap.timeline({
        repeat: -1,
        repeatDelay: 1.5,
        paused: true
      })
    };

    this.inView();

    if ($(".visualize-process").length) {
      this.processStepAnim();

      // Update div height
      setTimeout(function () {
        // Add delay because would get the wrong height
        gsap.to("#visualize-process-container .visualize-process", 0.5, {
          height: $("#visualize-process-container .process-flood").outerHeight(),
        });
      }, 10);

      $(window).on("resize", $.proxy(this.resize, this));
    }
  }

  processStepAnim() {
    $.each($(".visualize-process .process-steps"), $.proxy(function (index, el) {
      $.each($(el).find("> .step"), $.proxy(function (index_child, el_child) {
        var speed = index_child == 0 ? 0 : this.processStepSpeed;

        this.processStepTimelines[Object.keys(this.processStepTimelines)[index]].add(function () {
          var index = index_child;

          $($(el).find("> .step")[index]).addClass("current").siblings().removeClass("current");
        }, "+=" + speed + "");
      }, this));

    }, this));

    // Start first animation on inView
    if (window.viewport().width >= 768) {
      inView("#science .visualize-process").once("enter", $.proxy(function () {
        this.processStepTimelines[Object.keys(this.processStepTimelines)[0]].restart().play();
      }, this));
    }
  }

  // Animation using inview
  inView() {
    inView.offset({
      top: 100,
      bottom: 75
    });

    inView('.in-view').on('enter', function (el) {
      if ($(el).hasClass("animated") || $(el).hasClass("animation-done")) {
        return;
      }

      var animation = $(el).data("animation");
      var delay = $(el).data("animation-delay");
      var duration = $(el).data("animation-duration");

      if (delay !== null && delay !== '') {
        $(el).css("animation-delay", delay);
        $(el).css("transition-delay", delay);
      }

      if (duration !== null && duration !== '') {
        $(el).css("animation-duration", duration);
        $(el).css("transition-duration", duration);
      }

      $(el).addClass("animated");
      $(el).addClass(animation);
      $(el).removeClass("in-view");

      // Remove animation on element to enable parallax
      $(el).one('animationend webkitAnimationEnd oAnimationEnd', function () {
        $(el).addClass("animation-done").removeClass("animated").removeClass(animation).removeAttr("style");
      });
    });

  }

  resize() {
    // Disable process animation
    if (window.viewport().width < 768 && $("#science").length > 0) {
      $.each(this.processStepTimelines, $.proxy(function (el, index) {
        this.processStepTimelines[el].pause(0);
      }, this));
      $(".visualize-process .process-steps .step").removeClass("current");
    } else {
      $("#science .visualize-process").attr("style", "");
    }
  }

  dettach() {
    // console.log("anim: dettach()");
    $(window).off("resize", $.proxy(this.resize, this));
  }

}
